import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { sessionEvents } from "../events/sessionEvents";

/**
 * Clears the cached `/identity` query whenever the auth layer emits a
 * logout event. Mounted once at app root inside the QueryClientProvider.
 *
 * Why this lives outside `OrgIndicator`: PRD-003 DoD #10 prescribes a
 * specific clearing order — JWT first, then identity, then project
 * (PRD-004), then in-flight UI state. AuthContext.logout() emits
 * `auth:logout` synchronously *after* `jwtStore.clear()` runs, so
 * subscribers here see JWT-already-null and run after JWT clearing.
 *
 * PRD-004 will register another subscriber on the same event for project
 * context. Future PRDs (PRD-001 in-flight job UI state) follow the same
 * pattern.
 */
export function IdentityCacheCleaner() {
    const queryClient = useQueryClient();
    useEffect(() => {
        return sessionEvents.on("auth:logout", () => {
            queryClient.removeQueries({ queryKey: ["identity"] });
        });
    }, [queryClient]);
    return null;
}
